var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { commonCSS } from "../common";
import { mainStyles, boldStyles, regularStyles, labelWhite } from "./styles";
export default styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", " /* Default size, if no size prop is provided */\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  ", "\n  ", " /* Default size, if no size prop is provided */\n\n  ", "\n  ", "\n\n  ", "\n"])), mainStyles, regularStyles, function (_a) {
    var white = _a.white;
    return white && labelWhite;
}, function (_a) {
    var bold = _a.bold;
    return bold && boldStyles;
}, commonCSS);
var templateObject_1;
